import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
} from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { createElement } from 'react';
import { DatadogApiClient, datadogApiRef } from './api';
import { isDatadogAvailable } from './availability';

const datadogApi = ApiBlueprint.make({
  name: 'datadog',
  params: defineParams =>
    defineParams({
      api: datadogApiRef,
      deps: { discoveryApi: discoveryApiRef },
      factory: ({ discoveryApi }) => new DatadogApiClient({ discoveryApi }),
    }),
});

const datadogEntityContent = EntityContentBlueprint.make({
  name: 'dashboard',
  params: {
    path: '/datadog',
    title: 'Datadog',
    filter: entity =>
      isDatadogAvailable(entity) &&
      entity.kind.toLocaleLowerCase('en-US') !== 'user',
    loader: () =>
      import('./Router').then(module =>
        createElement(module.DatadogEntityContent),
      ),
  },
});

export const datadogDashboardPlugin = createFrontendPlugin({
  pluginId: 'datadog-dashboard',
  extensions: [datadogApi, datadogEntityContent],
});
